var _rect, _rect2, _polygon, _polygon2, _path, _circle, _path2, _circle2, _path3, _path4, _rect3, _path5, _rect4, _rect5, _rect6, _rect7, _rect8, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFuelTruck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 64 64",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26.5,
    height: 3.8,
    x: 31.2,
    y: 35.2,
    fill: "#445c6c"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 39.2,
    height: 5,
    x: 22.8,
    y: 39.1,
    fill: "#5dafd8"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#5dafd8",
    points: "2.3 27.3 11.9 13.7 22.8 13.7 22.8 44.1 2.3 44.1"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#445c6c",
    points: "18.9 17.4 18.9 28.9 6.6 28.9 13.5 17.4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#445c6c",
    d: "M20.1,43.3c0,3.9-3.1,7-7,7c-3.9,0-7-3.1-7-7c0-3.9,3.1-7,7-7C17,36.4,20.1,39.5,20.1,43.3z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.2,
    cy: 43.3,
    r: 4.3,
    fill: "#e1e7e7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#445c6c",
    d: "M43.7,43.3c0,3.9-3.1,7-7,7c-3.9,0-7-3.1-7-7c0-3.9,3.1-7,7-7C40.5,36.4,43.7,39.5,43.7,43.3z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.7,
    cy: 43.3,
    r: 4.3,
    fill: "#e1e7e7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#445c6c",
    d: "M59.2,43.3c0,3.9-3.1,7-7,7c-3.9,0-7-3.1-7-7c0-3.9,3.1-7,7-7C56.1,36.4,59.2,39.5,59.2,43.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1e7e7",
    d: "M56.5,43.3c0,2.4-1.9,4.3-4.3,4.3c-2.4,0-4.3-1.9-4.3-4.3c0-2.4,1.9-4.3,4.3-4.3 C54.6,39.1,56.5,41,56.5,43.3z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 2.3,
    height: 5,
    y: 39.1,
    fill: "#5dafd8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#445c6c",
    d: "M60.5,35.3H28.4c-7.9-10.1,0-18.9,0-18.9h32.1C60.5,16.4,68.4,25.2,60.5,35.3z"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 7.6,
    height: 1.2,
    x: 49.4,
    y: 18,
    fill: "#dadde1"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 7.6,
    height: 1.2,
    x: 49.4,
    y: 21.6,
    fill: "#dadde1"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 7.6,
    height: 1.2,
    x: 49.4,
    y: 25.2,
    fill: "#dadde1"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 7.6,
    height: 1.2,
    x: 49.4,
    y: 28.8,
    fill: "#dadde1"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 7.6,
    height: 1.2,
    x: 49.4,
    y: 32.4,
    fill: "#dadde1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#788d9a",
    d: "M48.7,15.7v20.1h1.4V17.1h6.2v18.7h1.4V15.7H48.7z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#5dafd8",
    d: "M44.7,26c0.9,1.9,0.1,4.2-1.8,5.1c-1.9,0.9-4.2,0.1-5.1-1.8c-0.5-1.1-0.5-2.3,0-3.3c0,0,3.4-7,3.5-7 C41.4,19,44.7,26,44.7,26z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuelTruck);
export default __webpack_public_path__ + "static/media/FuelTruck.1485f0cf33c27a17e1730318ff3bdace.svg";
export { ForwardRef as ReactComponent };